import { SelectOptionAmount } from 'types/layout';
import { ServiceLevelName } from 'types/service-level';

export const quickInvestResumeCheckoutPrompt =
	"You're seconds away from becoming an investor. We just need a few more pieces of information.";

export const paymentAmountOptions: Record<ServiceLevelName, Array<SelectOptionAmount>> = {
	STARTER: [
		{ value: '10', label: '$10', sortIndex: 10 },
		{ value: '100', label: '$100', sortIndex: 100 },
		{ value: '250', label: '$250', sortIndex: 250 },
		{ value: '500', label: '$500', sortIndex: 500, default: true },
		{ value: '750', label: '$750', sortIndex: 750 },
		{ value: 'other', label: 'Other', sortIndex: 1000000 }
	],
	BASIC: [
		{ value: '1000', label: '$1,000', sortIndex: 1000 },
		{ value: '2500', label: '$2,500', sortIndex: 2500, default: true },
		{ value: '5000', label: '$5,000', sortIndex: 5000 },
		{ value: 'other', label: 'Other', sortIndex: 1000000 }
	],
	CORE: [
		{ value: '5000', label: '$5,000', sortIndex: 5000 },
		{ value: '7500', label: '$7,500', sortIndex: 7500, default: true },
		{ value: '10000', label: '$10,000', sortIndex: 10000 },
		{ value: 'other', label: 'Other', sortIndex: 1000000 }
	],
	ADVANCED: [
		{ value: '10000', label: '$10,000', sortIndex: 10000 },
		{ value: '25000', label: '$25,000', sortIndex: 25000, default: true },
		{ value: '50000', label: '$50,000', sortIndex: 50000 },
		{ value: '100000', label: '$100,000', sortIndex: 100000 },
		{ value: 'other', label: 'Other', sortIndex: 1000000 }
	],
	PREMIUM: [
		{ value: '100000', label: '$100,000', sortIndex: 100000, default: true },
		{ value: '125000', label: '$125,000', sortIndex: 125000 },
		{ value: '150000', label: '$150,000', sortIndex: 150000 },
		{ value: 'other', label: 'Other', sortIndex: 1000000 }
	],
	NONE: [
		{ value: '1000', label: '$1,000', sortIndex: 1000 },
		{ value: '5000', label: '$5,000', sortIndex: 5000, default: true },
		{ value: '10000', label: '$10,000', sortIndex: 10000 },
		{ value: '25000', label: '$25,000', sortIndex: 25000 },
		{ value: '50000', label: '$50,000', sortIndex: 50000 },
		{ value: 'other', label: 'Other', sortIndex: 1000000 }
	],
	NON_RIA: [],
	'': []
};
